angular.module('app.financeiro').factory('remessaBancoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RemessaBanco';

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _list = function (search, options, dataInicio, dataTermino, situacao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _gerarRemessas = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GerarRemessas', dto);
    };

    var _cancelarRemessa = function (codigo) {
        var dto = {};
        dto.id = codigo;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/CancelarRemessa', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.list = _list;
    factory.findRecord = _findRecord;
    factory.gerarRemessas = _gerarRemessas;
    factory.cancelarRemessa = _cancelarRemessa;
    return factory;

}]);
